import React from 'react'

function Portfolio() {
  return (
    <section className='portfolio'>
      <h1>Our Portfolio</h1>
      <p>Explore our latest projects and achievements.</p>
    </section>
  )
}

export default Portfolio